import { globalData } from "../..";
import { assetUrl, processGender } from "../../env";
import createMessageHtml from "./createMessageHtml";

//LOOP THROUGH EACH MESSAGE AND PROCESS IT, RETURN ID AND HTML OF THE CORRESPONDING MESSAGE
const messagesProcess = () => {

    let { displayType, messages, video, isLive, smid, pname } = globalData;

    if (displayType === 'livefeedonly' || displayType === 'random') {
        isLive = true;
    }

    if (displayType === 'random') {

        smid = processGender().smid;
        pname = processGender().nameClean;

        //SET THE GLOBAL SMID AND PNAME
        globalData.smid = smid
        globalData.pname = pname

    }

    //push in extra message to create video or iframe with isLive
    switch (displayType) {
        case 'livefeedonly':
        case 'hybrid':
        case 'prerecordedonly':
        case 'random':
            if (isLive && smid && pname) {
                messages.unshift({
                    iframe: true
                })
            } else if (video) {
                messages.unshift({
                    video: true
                })
            }
            break
    }

    messages = messages.map(message => createMessageHtml(message))

    return messages

}

export { messagesProcess }